import { useNavigate } from 'react-router-dom'

import { BodyText, Button, Heading1 } from '@/components/core'
import { ROUTES } from '@/routes/paths'

import './index.scss'

export function OrganizationNoAccessScreen() {
  const navigate = useNavigate()

  const handleGoToOrganizations = () => {
    void navigate(ROUTES.ROOT.fullPath)
  }

  return (
    <div className="no-access-screen">
      <div className="no-access-container">
        <div className="no-access-header">
          <Heading1>Oops, no rights to access</Heading1>
          <BodyText>You don't have rights to access this workspace.</BodyText>
          <BodyText>Please contact workspace administrator.</BodyText>
        </div>

        <div className="no-access-actions">
          <Button variant="primary" onClick={handleGoToOrganizations}>
            Go to My Workspaces
          </Button>
        </div>
      </div>
    </div>
  )
}
